export default __webpack_public_path__ + "static/WBW-logo-88a5780bf1417257330c12a3be33de6e.svg";